import Logger from "slotworks/utils/logger";
import * as TweenJS from "slotworks/utils/tween";

import Contract from "slotworks/utils/contracts/contract";

export default class OldContract<T> extends Contract<T> {

    public static empty(): Contract<any> {
        return Contract.empty();
    }

    public static never(): Contract<any> {
        return Contract.never();
    }

    public static wrap<T>(method?: () => T): Contract<any> {
        return Contract.wrap(method);
    }

    public static wrapTween(tween: TweenJS.Tween): Contract<any> {
        return Contract.wrapTween(tween);
    }

    public static getTimeoutContract(duration: number): Contract<any> {
        return Contract.getTimeoutContract(duration);
    }

    public static getDelayedContract<T>(delay: number, callback: () => Contract<T>): Contract<T> {
        return Contract.getDelayedContract(delay, callback);
    }

    constructor(executor: (resolve: (value: T) => void) => (void | Contract<any>)) {
        super(executor);

        Logger.warn("Deprecated Contract package location. Please use slotworks/utils/contracts package instead");
    }
}
